import { getProfile } from "@/api/User";
import type { User } from "@/models";
import { computed, ref } from "vue";
import type { NullRef } from "@/utils";
import { getFidelityCardMovementsHistory } from "@/api/User";
import { useProfileValidator, type FidelityCardMovement } from "@/models/User";
import { OptionalUserFields, OptionalUserFieldsValues } from "@/models/App";
import { useApp } from "./app";

const user: NullRef<User> = ref();
const fidelityCardMovements: NullRef<FidelityCardMovement[]> = ref();

export function useUser() {
  const refreshUser = async () => {
    user.value = await getProfile();
  };

  const loadFidelityCardMovements = async () => {
    fidelityCardMovements.value = await getFidelityCardMovementsHistory();
  };

  const profile = computed(() => {
    return user.value ? {
      name: user.value.name,
      surname: user.value.surname,
      gender: user.value.gender,
      phone: user.value.phones?.[0],
      birthDate: user.value.birthDate,
    } : null;
  })

  const { isFieldMandatory } = useApp();
  const isProfileComplete = computed(() => {
    const { schema } = useProfileValidator({ gender: isFieldMandatory(OptionalUserFields.GENDER), birthDate: isFieldMandatory(OptionalUserFields.BIRTH_DATE) });
    return schema.isValidSync(profile.value);
  });

  return { user, fidelityCardMovements, refreshUser, loadFidelityCardMovements, profile, isProfileComplete };
}

